// JavaScript Document

$(window).on("load", function () {
  "use strict";

  /*----------------------------------------------------*/
  /*	Preloader
  /*----------------------------------------------------*/

  $("#spice-loader").delay(100).fadeOut();
  $("#spice-loader").delay(100).fadeOut("fast");
});

$(document).ready(function () {
  "use strict";

  /*----------------------------------------------------*/
  /*	Hero Slider
  /*----------------------------------------------------*/
  // Mapeo simple EN -> ES para los errores comunes
window.prettyMessage = (raw) => {
  // i18n simple
  const t = (k, fb = '') =>
    k.split('.').reduce((o, p) => (o && o[p] !== undefined ? o[p] : undefined), window.qbaI18n) ?? fb;

  // i18n con interpolación
  const ti = (k, params = {}, fb = '') => {
    let s = t(k, fb);
    for (const [key, val] of Object.entries(params)) {
      s = s
        .replaceAll(`{{${key}}}`, String(val))
        .replaceAll(`%{${key}}`, String(val));
    }
    return s;
  };

  // Permitir uso programático: prettyMessage({ key:'cart.errors.only_n_left', params:{count:2,in_cart:1} })
  if (raw && typeof raw === 'object' && raw.key) {
    return ti(raw.key, raw.params || {}, raw.fb || '');
  }

  // Errores crudos de Shopify
  if (!raw) return t('cart.errors.generic', 'Error al agregar al carrito.');
  const s = String(raw);

  if (/maximum quantity/i.test(s))         return t('cart.errors.max_quantity', s);
  if (/is not available/i.test(s))         return t('cart.errors.variant_unavailable', s);
  if (/requires a selling plan/i.test(s))  return t('cart.errors.selling_plan_required', s);

  // Fallback genérico traducido
  return t('cart.errors.generic', s);
};
// =============================================
// DETECCIÓN DE REGIÓN
// =============================================
const localization = async () => {
  try {
    const result = await fetch("/browsing_context_suggestions.json");
    const resultJson = await result.json();
    return resultJson.detected_values.country.handle;
  } catch(error) {
    console.log(error);
    return null;
  }
}

const decodeHTML = (html) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

// =============================================
// OCULTAR CARRITO SEGÚN REGIÓN
// =============================================
const configurarCarritoSegunRegion = async () => {
  const paisCodigo = await localization();
  
  const botonCarrito = document.querySelector('.basket-ico');
  
  // Ocultar carrito si NO es Colombia o USA
  if (paisCodigo !== "CO" && paisCodigo !== "US") {
    if (botonCarrito) {
      botonCarrito.style.display = 'none';
    }
  }
}

// =============================================
// MANEJAR BOTÓN DE CHECKOUT EN CARRITO
// =============================================
const manejarCheckoutCarrito = async () => {
  if (!window.paymentConfig) {
    console.warn('Payment config no encontrada');
    return;
  }
  
  const paisCodigo = await localization();
  const config = window.paymentConfig;

  
  // Buscar el botón de checkout
  const botonCheckout = document.querySelector('button[name="checkout"]');
  
  if (!botonCheckout) {
    console.warn('No se encontró el botón de checkout');
    return;
  }
  
  // Obtener el contenedor
  const contenedor = botonCheckout.parentElement;
  
  // COLOMBIA -> Wompi
if (paisCodigo === config.colombiaCountry) {
  botonCheckout.style.display = 'none';
  
  const botonWompi = document.createElement('button');
  botonWompi.type = 'button';
  botonWompi.className = 'btn btn-md tra-white tra-white-hover';
  botonWompi.style.backgroundColor = '#00D4B4';
  botonWompi.innerHTML = `
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style="margin-right: 8px; vertical-align: middle;">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>
    ${decodeHTML(config.buttonTexts.wompi)}
  `;
  
  botonWompi.addEventListener('click', () => {
    // Aquí mandas al formulario que tú creaste en Shopify
    window.location.href = '/pages/wompi-checkout';
  });

  contenedor.appendChild(botonWompi);
}
  // USA -> Shopify Payments (mantener comportamiento normal)
  else if (paisCodigo === config.usaCountry) {
    // Mantener el botón normal
  }
  // OTROS PAÍSES -> WhatsApp
  else {
    
    // Ocultar botón original
    botonCheckout.style.display = 'none';
    
    // Crear botón de WhatsApp
    const botonWhatsApp = document.createElement('a');
    botonWhatsApp.href = '#';
    botonWhatsApp.className = 'btn btn-md tra-white tra-white-hover';
    botonWhatsApp.style.backgroundColor = '#25D366';
    botonWhatsApp.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style="margin-right: 8px; vertical-align: middle;">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
      </svg>
      ${decodeHTML(config.buttonTexts.whatsapp)}
    `;
    
    botonWhatsApp.addEventListener('click', async (e) => {
      e.preventDefault();
      await enviarCarritoPorWhatsApp(config);
    });
    
    contenedor.appendChild(botonWhatsApp);
  }
}

// =============================================
// INTEGRACIÓN CON WOMPI DESDE CARRITO
// =============================================

// window.iniciarPagoWompiDesdeCarrito = async (config, checkoutData = null, shippingCentsToSend = 0) => {
//   try {
//     // 1. Obtener items del carrito
//     const cartResponse = await fetch('/cart.js');
//     const cart = await cartResponse.json();

//     if (cart.item_count === 0) {
//       console.log(window.configGeneral.error_checkout_payment);
//       notify(window.configGeneral.error_checkout_payment, 'error');
//       return;
//     }

//     // 2. Preparar line_items para Shopify (variant_id + quantity)
//     const lineItems = cart.items.map((item) => ({
//       variant_id: item.variant_id,
//       quantity: item.quantity,
//     }));

//     // 3. Calcular totales (subtotal + envío)
//     const subtotalCents = cart.total_price; // centavos
//     const shippingCents = shippingCentsToSend || 0;
//     const totalCents = subtotalCents + shippingCents;

//     // 4. Crear draft + URL Wompi
//     const response = await fetch(
//       'https://wompi-webhook-six.vercel.app/api/create-wompi-checkout',
//       {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           line_items: lineItems,
//           amountInCents: totalCents,
//           subtotalCents: subtotalCents,
//           shippingCents: shippingCents,
//           checkout: checkoutData
//         }),
//       }
//     );

//     // ✅ Leer JSON incluso si falla para capturar data.error
//     const data = await response.json().catch(() => ({}));

//     if (!response.ok) {
//       console.error('Error desde create-wompi-checkout:', data);
//       notify(
//         data.error || prettyMessage({ key: 'cart.errors.error_payment' }, 'error'),
//         'error'
//       );
//       return;
//     }

//     if (!data.url) {
//       notify('No se pudo generar la URL de pago. Intenta nuevamente.', 'error');
//       return;
//     }

//     // 5. Vaciar carrito SOLO si ya tengo URL válida
//     try {
//       await fetch('/cart/clear.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' }
//       });
//     } catch (clearError) {
//       console.warn('⚠️ No se pudo vaciar el carrito:', clearError);
//       // no es crítico
//     }

//     // 6. Redirigir
//     window.location.href = data.url;
//   } catch (error) {
//     console.error('Error al iniciar pago con Wompi:', error);
//     notify('Hubo un error al procesar tu pago. Por favor, intenta nuevamente.', 'error');
//   }
// };

window.iniciarPagoWompiDesdeCarrito = async (config, payload) => {
  localStorage.setItem('qba_pending_wompi', '1');

  try {
    const response = await fetch(config.wompi_endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      console.error('Error desde create-wompi-checkout:', data);
      notify(data.error || 'Error generando pago', 'error');
      return;
    }

    if (!data.url) {
      notify('No se pudo generar la URL de pago. Intenta nuevamente.', 'error');
      return;
    }

    // ⚠️ Recomendado: NO vaciar carrito aquí (hazlo en gracias/confirmación)
    window.location.href = data.url;
  } catch (error) {
    console.error('Error al iniciar pago con Wompi:', error);
    notify('Hubo un error al procesar tu pago. Por favor, intenta nuevamente.', 'error');
  }
};



// =============================================
// ENVIAR CARRITO POR WHATSAPP
// =============================================
const enviarCarritoPorWhatsApp = async (config) => {
  try {
    // Obtener items del carrito
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    if (cart.item_count === 0) {
      alert('Tu carrito está vacío');
      return;
    }
    
    // Construir mensaje con los productos
    let mensaje = 'Hola, estoy interesado en realizar la siguiente compra:\n\n';
    
    cart.items.forEach((item, index) => {
      mensaje += `${index + 1}. ${item.product_title}`;
      if (item.variant_title && item.variant_title !== 'Default Title') {
        mensaje += ` - ${item.variant_title}`;
      }
      mensaje += ` x${item.quantity}\n`;
    });
    
    mensaje += `\nTotal: ${formatMoney(cart.total_price)}\n\n`;
    mensaje += 'Deseo más información para completar mi pedido.';
    
    console.log('Enviando mensaje por WhatsApp:', mensaje);
    
    const urlWhatsApp = `https://wa.me/${config.whatsappNumber}?text=${encodeURIComponent(mensaje)}`;
    
    window.open(urlWhatsApp, '_blank');
    
  } catch (error) {
    console.error('Error al enviar carrito por WhatsApp:', error);
    alert('Hubo un error. Por favor, intenta nuevamente.');
  }
}

// =============================================
// FUNCIÓN AUXILIAR PARA FORMATEAR DINERO
// =============================================
const formatMoney = (cents) => {
  return (cents / 100).toLocaleString('es-CO', {
    style: 'currency',
    currency: 'COP'
  });
}

// =============================================
// INICIALIZAR AL CARGAR LA PÁGINA
// =============================================
  configurarCarritoSegunRegion();
  
  // Detectar si estamos en la página del carrito
  const esCarrito = document.querySelector('.cart-page, #cart-1, section[id*="cart"]');
  
  if (esCarrito) {
    manejarCheckoutCarrito();
  } else {
  }



  $(".slider").slider({
    full_width: false,
    interval: 6000,
    transition: 1000,
    draggable: false,
    indicators: true,
  });

  $(".slide-next").click(function () {
    $(".slider").slider("next");
  });

  $(".slide-prev").click(function () {
    $(".slider").slider("prev");
  });

  /*----------------------------------------------------*/
  /*	Animated Scroll To Anchor
  /*----------------------------------------------------*/

  $(
    '.header a[href^="#"], .wsmenu a[href^="#"], .page a.btn[href^="#"], .page a.internal-link[href^="#"]'
  ).on("click", function (e) {
    e.preventDefault();

    var target = this.hash,
      $target = jQuery(target);

    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - 60, // - 200px (nav-height)
        },
        "slow",
        "easeInSine",
        function () {
          window.location.hash = "1" + target;
        }
      );
  });

  /*----------------------------------------------------*/
  /*	ScrollUp
  /*----------------------------------------------------*/

  $.scrollUp = function (options) {
    // Defaults
    var defaults = {
      scrollName: "scrollUp", // Element ID
      topDistance: 600, // Distance from top before showing element (px)
      topSpeed: 800, // Speed back to top (ms)
      animation: "fade", // Fade, slide, none
      animationInSpeed: 200, // Animation in speed (ms)
      animationOutSpeed: 200, // Animation out speed (ms)
      scrollText: "", // Text for element
      scrollImg: false, // Set true to use image
      activeOverlay: false, // Set CSS color to display scrollUp active point, e.g '#00FFFF'
    };

    var o = $.extend({}, defaults, options),
      scrollId = "#" + o.scrollName;

    // Create element
    $("<a/>", {
      id: o.scrollName,
      href: "#top",
      title: o.scrollText,
    }).appendTo("body");

    // If not using an image display text
    if (!o.scrollImg) {
      $(scrollId).text(o.scrollText);
    }

    // Minium CSS to make the magic happen
    $(scrollId).css({ display: "none", position: "fixed", "z-index": "99999" });

    // Active point overlay
    if (o.activeOverlay) {
      $("body").append("<div id='" + o.scrollName + "-active'></div>");
      $(scrollId + "-active").css({
        position: "absolute",
        top: o.topDistance + "px",
        width: "100%",
        "border-top": "1px dotted " + o.activeOverlay,
        "z-index": "99999",
      });
    }

    // Scroll function
    $(window).on("scroll", function () {
      switch (o.animation) {
        case "fade":
          $(
            $(window).scrollTop() > o.topDistance
              ? $(scrollId).fadeIn(o.animationInSpeed)
              : $(scrollId).fadeOut(o.animationOutSpeed)
          );
          break;
        case "slide":
          $(
            $(window).scrollTop() > o.topDistance
              ? $(scrollId).slideDown(o.animationInSpeed)
              : $(scrollId).slideUp(o.animationOutSpeed)
          );
          break;
        default:
          $(
            $(window).scrollTop() > o.topDistance
              ? $(scrollId).show(0)
              : $(scrollId).hide(0)
          );
      }
    });

    // To the top
    $(scrollId).on("click", function (event) {
      $("html, body").animate({ scrollTop: 0 }, o.topSpeed);
      event.preventDefault();
    });
  };

  $.scrollUp();

  /*----------------------------------------------------*/
  /*	DateTimePicker
  /*----------------------------------------------------*/

  $("#datetimepicker").datetimepicker();

  /*----------------------------------------------------*/
  /*	Tabs #1
  /*----------------------------------------------------*/

  $("ul.tabs-1 li").on("click", function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs-1 li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  /*----------------------------------------------------*/
  /*	Tabs #2
  /*----------------------------------------------------*/

  $("ul.tabs-2 li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs-2 li").removeClass("displayed");
    $(".tab-content").removeClass("displayed");

    $(this).addClass("displayed");
    $("#" + tab_id).addClass("displayed");
  });

  /*----------------------------------------------------*/
  /*	Reviews Rotator Flexslider
  /*----------------------------------------------------*/

  $("#reviews-1 .flexslider").flexslider({
    animation: "fade",
    controlNav: true,
    directionNav: false,
    slideshowSpeed: 5000,
    animationSpeed: 2000,
    start: function (slider) {
      $("body").removeClass("loading");
    },
  });

  /*----------------------------------------------------*/
  /*	Single Image Lightbox
  /*----------------------------------------------------*/

  $(".image-link").magnificPopup({
    type: "image",
  });

  /*----------------------------------------------------*/
  /*	Video Link #1 Lightbox
  /*----------------------------------------------------*/

  $(".video-popup1").magnificPopup({
    type: "iframe",
    iframe: {
      patterns: {
        youtube: {
          index: "youtube.com",
          src: "https://www.youtube.com/embed/SZEflIVnhH8",
        },
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Video Link #2 Lightbox
  /*----------------------------------------------------*/

  $(".video-popup2").magnificPopup({
    type: "iframe",
    iframe: {
      patterns: {
        youtube: {
          index: "youtube.com",
          src: "https://www.youtube.com/embed/7e90gBu4pas",
        },
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Video Link #3 Lightbox
  /*----------------------------------------------------*/

  $(".video-popup3").magnificPopup({
    type: "iframe",
    iframe: {
      patterns: {
        youtube: {
          index: "youtube.com",
          src: "https://www.youtube.com/embed/0gv7OC9L2s8",
        },
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Testimonials Rotator
  /*----------------------------------------------------*/

  var owl = $(".promo-holder");
  owl.owlCarousel({
    items: 3,
    loop: true,
    autoplay: true,
    navBy: 1,
    nav: true,
    dots: false,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    smartSpeed: 1500,
    responsive: {
      0: {
        items: 1,
      },
      767: {
        items: 1,
      },
      768: {
        items: 2,
      },
      991: {
        items: 3,
      },
      1000: {
        items: 3,
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Testimonials Rotator
  /*----------------------------------------------------*/

  var owl = $(".promo-8-carousel");
  owl.owlCarousel({
    items: 3,
    loop: true,
    autoplay: true,
    navBy: 1,
    nav: false,
    dots: false,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    smartSpeed: 1500,
    responsive: {
      0: {
        items: 1,
      },
      767: {
        items: 1,
      },
      768: {
        items: 2,
      },
      991: {
        items: 2,
      },
      1000: {
        items: 2,
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Gallery Photo Rotator
  /*----------------------------------------------------*/

  var owl = $(".images-carousel");
  owl.owlCarousel({
    items: 4,
    loop: true,
    autoplay: true,
    navBy: 1,
    autoplayTimeout: 4500,
    autoplayHoverPause: false,
    smartSpeed: 3000,
    responsive: {
      0: {
        items: 1,
      },
      640: {
        items: 1,
      },
      767: {
        items: 2,
      },
      768: {
        items: 2,
      },
      991: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Testimonials Rotator
  /*----------------------------------------------------*/

  var owl = $(".reviews-wrapper");
  owl.owlCarousel({
    items: 3,
    loop: true,
    autoplay: true,
    navBy: 1,
    autoplayTimeout: 4500,
    autoplayHoverPause: true,
    smartSpeed: 1500,
    responsive: {
      0: {
        items: 1,
      },
      767: {
        items: 1,
      },
      768: {
        items: 2,
      },
      991: {
        items: 3,
      },
      1000: {
        items: 3,
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Brands Logo Rotator
  /*----------------------------------------------------*/

  var owl = $(".brands-carousel");
  owl.owlCarousel({
    items: 5,
    loop: true,
    autoplay: true,
    navBy: 1,
    nav: false,
    autoplayTimeout: 4000,
    autoplayHoverPause: false,
    smartSpeed: 2000,
    responsive: {
      0: {
        items: 2,
      },
      550: {
        items: 3,
      },
      767: {
        items: 3,
      },
      768: {
        items: 4,
      },
      991: {
        items: 5,
      },
      1000: {
        items: 6,
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Product Variants
  /*----------------------------------------------------*/

  $(".js-product-select").on("change", function () {
    var option = $(this).attr("data-option");
    var value = $(this).val();
    var productId = $(this).attr("data-product-id");

    $(
      ".js-product[data-product-id='" +
        productId +
        "'] #product-variants select[data-option='" +
        option +
        "']"
    )
      .val(value)
      .change();

    return false;
  });

  var variants = function (productId) {
    var data = JSON.parse(
      document.getElementById("ProductJson" + productId + "").innerHTML
    );
    var selectCallback = function (variant, selector) {
      var that = $(".js-product[data-product-id='" + productId + "']");
      if (variant) {
        if (variant.compare_at_price > variant.price) {
          $(that)
            .find(".old-price")
            .removeClass("d-none")
            .html(Shopify.formatMoney(variant.compare_at_price));
          $(that)
            .find(".default-price")
            .html(Shopify.formatMoney(variant.price));
        } else {
          $(that).find(".old-price").addClass("d-none");
          $(that)
            .find(".default-price")
            .html(Shopify.formatMoney(variant.price));
        }
      }
      if (variant.id == selector.product.variants[1].id) {
        $(that).find(".js-small-capacity").removeClass("d-none");
        $(that).find(".js-large-capacity").addClass("d-none");
        $(that).find(".js-small-calories").removeClass("d-none");
        $(that).find(".js-large-calories").addClass("d-none");
      } else {
        $(that).find(".js-small-capacity").addClass("d-none");
        $(that).find(".js-large-capacity").removeClass("d-none");
        $(that).find(".js-small-calories").addClass("d-none");
        $(that).find(".js-large-calories").removeClass("d-none");
      }
    };
    jQuery(function ($) {
      if ($("#product-select-" + productId + "").length > 0) {
        new Shopify.OptionSelectors("product-select-" + productId + "", {
          product: data,
          onVariantSelected: selectCallback,
          enableHistoryState: true,
        });
      }
    });
  };

  $(".js-product-variants").each(function () {
    variants($(this).attr("data-product-id"));
  });

  /*----------------------------------------------------*/
  /*	Related Products
  /*----------------------------------------------------*/

  var relatedProducts = function () {
    if ($(".product-recommendations").length > 0) {
      loadRelatedProducts();
    }
    function loadRelatedProducts() {
      var productRecommendationsSection = document.querySelector(
        ".product-recommendations"
      );
      if (productRecommendationsSection === null) {
        return;
      }
      var productId = $(".product-recommendations").attr("data-product-id");
      var limit = $(".product-recommendations").attr("data-limit");
      var requestUrl =
        "/recommendations/products?section_id=related_products&limit=" +
        limit +
        "&product_id=" +
        productId;
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML =
            container.querySelector(".product-recommendations").innerHTML;
        }
      };
      request.send();
    }
  };
  relatedProducts();

  /*----------------------------------------------------*/
  /*	Account Login
  /*----------------------------------------------------*/

  var accountLogin = function () {
    $(".js-go-to-forgotten-password").click(function () {
      $(".js-login").addClass("d-none");
      $(".js-forgotten-password").removeClass("d-none");
      return false;
    });
    $(".js-back-to-login").click(function () {
      $(".js-login").removeClass("d-none");
      $(".js-forgotten-password").addClass("d-none");
      return false;
    });
  };

  accountLogin();

  /*----------------------------------------------------*/
  /*	Wishlist
  /*----------------------------------------------------*/

  var wishlist = function () {
    $(".js-add-to-wishlist").each(function () {
      var productHandle = $(this).attr("data-product-handle") + ",";
      var wishlist = localStorage.getItem("wishlist");
      if (wishlist == null) {
        wishlist = "";
      }
      if (wishlist.indexOf(productHandle) >= 0) {
        $(this).addClass("active");
      }
    });
    $("body").on("click", ".js-add-to-wishlist", function () {
      var productHandle = $(this).attr("data-product-handle");
      var getWishlistProducts = localStorage.getItem("wishlist");
      if (getWishlistProducts == null) {
        getWishlistProducts = "";
      }
      getWishlistProducts = getWishlistProducts.replace(
        productHandle + ",",
        ""
      );

      if (!$(this).hasClass("active")) {
        $(this).addClass("active");

        localStorage.setItem(
          "wishlist",
          getWishlistProducts + productHandle + ","
        );
        return false;
      } else {
        $(this).removeClass("active");

        localStorage.setItem("wishlist", getWishlistProducts);
        return false;
      }
    });
  };
  wishlist();

  /*----------------------------------------------------*/
  /*	Refresh Cart Count
  /*----------------------------------------------------*/

  var refreshCart = function () {
    jQuery.getJSON("/cart.js", function (cart) {
      $(".js-cart-count").html(cart.item_count);
    });
  };
});

/* QBA: Add to Cart con fetch (sin jQuery) + validación de stock */
(() => {
  let busy = false;

  // util: actualizar contador del carrito
  const refreshCartCount = () =>{
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const el = document.querySelector('.js-cart-count');
        if (el) el.textContent = cart.item_count;
        setTimeout(()=>{
          location.reload();
        },1000)
        
      })
      .catch((err) => {console.log(err)})
    };

  // util: mostrar toast en lugar de alert
  window.notify = (msg, type = 'success') => {
    // Crear el toast
    const toast = document.createElement('div');
    toast.className = `qba-toast qba-toast-${type}`;
    toast.textContent = msg;
    
    // Agregar al body
    document.body.appendChild(toast);
    
    // Animación de entrada
    setTimeout(() => toast.classList.add('qba-toast-show'), 10);
    
    // Remover después de 3 segundos
    setTimeout(() => {
      toast.classList.remove('qba-toast-show');
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  };

  // Estilos del toast (si no tienes CSS, esto lo agrega automáticamente)
  if (!document.getElementById('qba-toast-styles')) {
    const style = document.createElement('style');
    style.id = 'qba-toast-styles';
    style.textContent = `
      .qba-toast {
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 16px 24px;
        border-radius: 8px;
        color: white;
        font-weight: 500;
        z-index: 999999;
        opacity: 0;
        transform: translateY(-20px);
        transition: all 0.3s ease;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        max-width: 400px;
      }
      .qba-toast-show {
        opacity: 1;
        transform: translateY(0);
      }
      .qba-toast-success {
        background: var(--qba-purple);
      }
      .qba-toast-error {
        background: #ef4444;
      }
      .qba-toast-warning {
        background: var(--qba-orange);
      }
    `;
    document.head.appendChild(style);
  }




  // util: obtener stock disponible de la variante
  const getAvailableStock = (btn, variantId) => {
    // 1) Intentar desde data-attribute
    let stock = btn.dataset.inventoryQuantity;
    if (stock !== undefined && stock !== null && stock !== '') {
      return Number(stock);
    }

    // 2) Intentar desde ProductJson en la página
    const productId = btn.dataset.productId;
   
    if (productId) {
      const jsonEl = document.getElementById('ProductJson' + productId);
      if (jsonEl) {
        try {
          const productData = JSON.parse(jsonEl.innerHTML);
          const variant = productData.variants?.find(v => v.id == variantId);
          if (variant && variant.inventory_quantity !== undefined) {
            return Number(variant.inventory_quantity);
          }
        } catch (e) {
          console.warn('[qba] No se pudo parsear ProductJson:', e);
        }
      }
    }

    // 3) No se encontró información de stock
    return null;
  };

  // Capturing=true para adelantarnos a scripts del theme/app
  document.addEventListener('click', async (ev) => {
    const btn = ev.target.closest('.js-btn-add-to-cart, .js-add-to-cart');
    if (!btn) return;

    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();

    if (busy) return;
    busy = true;

    try {
      // 1) Obtener variant_id
      let id =
        btn.dataset.variantId ||
        document.querySelector('form[action="/cart/add"] [name="id"]')?.value;

      // 2) Cantidad - buscar en múltiples lugares y formatos
      let quantity;
      const productRight = btn.closest('.product-right');
      const productContainer = btn.closest('.js-product, .product, [data-product-id]');
      const productId = btn.dataset.productId;
      
      // Buscar input de cantidad en diferentes lugares y con diferentes selectores
      if (productRight) {
        const qtyInput = productRight.querySelector('[name="quantity"]') || 
                        productRight.querySelector('.js-quantity-field') ||
                        productRight.querySelector('.qty') ||
                        (productId ? document.getElementById('qty-' + productId) : null);
        if (qtyInput) quantity = qtyInput.value;
      }
      
      if (!quantity && productContainer) {
        const qtyInput = productContainer.querySelector('[name="quantity"]') ||
                        productContainer.querySelector('.js-quantity-field') ||
                        productContainer.querySelector('.qty') ||
                        (productId ? document.getElementById('qty-' + productId) : null);
        if (qtyInput) quantity = qtyInput.value;
      }
      
      if (!quantity) {
        quantity = document.querySelector('form[action="/cart/add"] [name="quantity"]')?.value;
      }
      
      if (!quantity) {
        quantity = 1;
      }

      quantity = Number(quantity) || 1;

      id = Number(id);

      if (!id) {
        prettyMessage()
        return;
      }

      // 3) Verificar stock disponible
      const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartRes.json();
      
      // Buscar si ya está en el carrito
      const itemInCart = cart.items.find(item => item.variant_id == id);
      const quantityInCart = itemInCart ? itemInCart.quantity : 0;

      // Obtener stock disponible
      const availableStock = getAvailableStock(btn, id);

// Validar stock si tenemos la información
if (availableStock !== null && availableStock !== undefined) {
  if (quantityInCart + quantity > availableStock) {
    const remaining = availableStock - quantityInCart;

    if (remaining <= 0) {
      // Caso: no se puede agregar más
      notify(prettyMessage({
          key: 'cart.errors.only_n_left',
          params: { count: remaining, in_cart: quantityInCart }
        }), 'warning');
    } else {
      // Caso: quedan N unidades → usamos i18n con params, pero SIEMPRE vía prettyMessage
      notify(
        prettyMessage({
          key: 'cart.errors.only_n_left',
          params: { count: remaining, in_cart: quantityInCart }
        }),
        'warning'
      );
    }
    return;
  }
}

      // 4) Agregar al carrito
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: new URLSearchParams({ id: String(id), quantity: String(quantity) })
      });

      const payload = await res.json().catch(() => ({}));

      if (!res.ok) {
        // Shopify suele dar .description o .message
        const msg = prettyMessage(payload?.description || payload?.message || `Error ${res.status}`);
        console.group('[qba] Cart Add FAIL');
        console.groupEnd();
        notify(msg, 'error');
        return;
      }

      await refreshCartCount();
      notify(prettyMessage({
          key: 'cart.errors.success'}, 'success'));
    } catch (err) {
      console.log(err)
      notify(prettyMessage({
          key: 'cart.errors.generic'}, 'error'));
    } finally {
      busy = false;
    }
  }, true); 
  document.addEventListener('click', function (ev) {
  const card = ev.target.closest('.menu-6-item[data-url]');
  if (!card) return;

  // No navegar si el click fue en el botón de carrito, corazones, badges, o cualquier <a>/<button>
  if (ev.target.closest('.js-add-to-cart, .like-ico, .stamped-main-badge, a, button')) return;

  window.location.href = card.dataset.url;
});
 
})();


